import { h } from 'preact'
import formatDateInLocalTimezone from '../../utils/dateFormatting'

type Invite = {
  createdAt: string,
  validUntil: string
}

const InviteStatusCell = () => {
  return ({ invite } : { invite: Invite }) => {
    if (!invite) return 'Not invited'

    const { createdAt, validUntil } = invite
    if (new Date(validUntil) < new Date()) return 'Invite expired'

    return <div>Invited on {formatDateInLocalTimezone(new Date(createdAt).getTime() / 1000 | 0)}</div>
  }
}

export default InviteStatusCell
